<script setup lang="ts">
import { XIcon } from "lucide-vue-next";
import SimpleButton from "./SimpleButton.vue";
</script>

<template>
  <SimpleButton variant="ghost" size="icon" class="rounded-full">
    <XIcon class="size-4" aria-hidden="true" />
    <span class="sr-only">Close</span>
  </SimpleButton>
</template>
